/* eslint-disable default-param-last */

import * as actionTypes from 'actions'

const initialState = {
  documentoInvalido: false,
  idExameRealizado: null,
  idTermo: null,
  dados: {
    codigoValidacao: null,
    numeroExame: null,
    tipoExame: null,
  },
}

const pdfReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.DOCUMENTO_EXAME_SOLICITADO_VALIDO: {
      return {
        ...initialState,
        idExameSolicitado: action.documentoValidado.id_exame_solicitado,
        dados: {
          codigoValidacao: action.documentoValidado.codigo_validacao,
        },
      }
    }
    case actionTypes.DOCUMENTO_TERMO_NAO_CONFORMIDADE_VALIDO: {
      return {
        ...initialState,
        idTermo: action.documentoValidado.id_termo_nao_conformidade,
        dados: {
          codigoValidacao: action.documentoValidado.codigo_validacao,
        },
      }
    }
    case actionTypes.DOCUMENTO_VALIDO: {
      return {
        ...initialState,
        idExameRealizado: action.documentoValidado.id_exame_realizado,
        dados: {
          codigoValidacao: action.documentoValidado.codigo_validacao,
          numeroExame: action.documentoValidado.exameRealizado.numero_exame,
          tipoExame: action.documentoValidado.exameRealizado.tipo,
        },
      }
    }

    case actionTypes.DOCUMENTO_INVALIDO: {
      return {
        ...initialState,
        documentoInvalido: true,
      }
    }

    default: {
      return state
    }
  }
}

export default pdfReducer
